import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface TabState {
    activeTab: number;
    accTypeTabs: string[];
    liabilityTypeTabs: string[];
    activAccTypeTab: string;
    activePaymentsTab: string;
    activeTransferTab: string;
}

const initialState: TabState = {
    activeTab: 1,
    accTypeTabs: ["CASA", "DEPOSIT"],
    liabilityTypeTabs: ["LOANS", "CARDS"],
    activAccTypeTab: "CASA",
    activePaymentsTab: "Quick Transfer",
    activeTransferTab: "Upcoming Transfers",
};

const tabSlice = createSlice({
    name: 'tabs',
    initialState,
    reducers: {
        setActiveTab(state, action: PayloadAction<number>) {
            state.activeTab = action.payload;
        },
        setActivAccTypeTab(state, action: PayloadAction<string>) {
            state.activAccTypeTab = action.payload;
        },
        setActivePaymentsTab(state, action: PayloadAction<string>) {
            state.activePaymentsTab = action.payload;
        },
        setActiveTransferTab(state, action: PayloadAction<string>) {
            state.activeTransferTab = action.payload;
        },
        resetActiveTab(state) {
            state.activeTab = 1;
        }
    }
});

export const { 
    setActiveTab, 
    setActivAccTypeTab, 
    resetActiveTab, 
    setActivePaymentsTab, 
    setActiveTransferTab 
} = tabSlice.actions;

export default tabSlice.reducer;